import { NavLink } from 'react-router-dom';
import { Toolbar, styled } from '@mui/material';
import { canOperate, useRoleOpContext, variables } from '..';

export function SubHeader() {
  const { operations } = useRoleOpContext();

  return (
    <Toolba variant="dense">
      <NavLin to={`my-information`}>My Information</NavLin>

      {canOperate(operations)('approve') && (
        <NavLin to={`my-team`}>Registrants and Coordinators</NavLin>
      )}

      {canOperate(operations)('admin') && (
        <NavLin to={`admin`}>Registration Authorities (RAs)</NavLin>
      )}

      {canOperate(operations)('di') && (
        <NavLin to={`di`}>Diversion Investigators (DIs)</NavLin>
      )}

      {canOperate(operations)('helpDesk') && (
        <NavLin to={`help-desk`}>Helpdesk Support</NavLin>
      )}

      {canOperate(operations)('rps') && (
        <NavLin to={`rps`}>Registration Program Specialist (RPS)</NavLin>
      )}
      
      {canOperate(operations)('operations') && (
        <NavLin to={`operations`}>Operations Support</NavLin>
      )}
    </Toolba>
  );
}

const Toolba = styled(Toolbar)(({ theme }) => ({
  boxShadow: '0 8px 6px -6px #808080',
  flexWrap: 'wrap',

  '&>*+*': {
    marginLeft: '2rem',
  },

  '&>.active': variables.activeLink,
}));

const NavLin = styled(NavLink)(({ theme }) => ({
  color: variables.brandCBP,
  fontSize: '1.6rem',
  fontWeight: 500,

  textDecoration: 'none',

  paddingTop: '0.5rem',

  // variables.link
  borderBottomStyle: 'solid',
  borderBottomWidth: '1px',
  '&:active, &:hover': variables.activeLink,
}));
